export default __webpack_public_path__ + "static/media/case-study-13-network-infrastructure.a1afe6c9.mp4";